// extracted by mini-css-extract-plugin
export default {"label":"FormLabel-label-gwvhu","hasError":"FormLabel-hasError-Q3yuI","isAdvanced":"FormLabel-isAdvanced-EuOsg","small":"FormLabel-small-SkLXp","large":"FormLabel-large-KjVUJ"};